/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CoreApiClientService } from 'pn-core-code';

import { apiBaseUrl } from '../api-base-url';
import { ProductCategoryDropdownResponseDto } from '../model/productCategoryDropdownResponseDto';
import { ProductCategoryPaginationResponseDto } from '../model/productCategoryPaginationResponseDto';
import { ProductCategoryRequestDto } from '../model/productCategoryRequestDto';
import { ProductCategoryResponseDto } from '../model/productCategoryResponseDto';
import { ValidationError } from '../model/validationError';

export enum productCategoriesDropdownGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum productCategoriesGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum productCategoriesIdGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum productCategoriesPublicGetLanguageEnum {
  th = 'th',
  en = 'en',
}

@Injectable({
  providedIn: 'root',
})
export class ProductCategoriesService {

  constructor(
    protected api: CoreApiClientService) {
  }

  /**
   * [Authorize] type: http
   */
  public productCategoriesDropdownGet$(page?: number, limit?: number, name?: string, language?: string, isActive?: boolean, filterHasProduct?: boolean, sort?: string): Observable<Array<ProductCategoryDropdownResponseDto>> {
    return this.api.get(`${apiBaseUrl()}/product-categories/dropdown`, { page, limit, name, language, isActive, filterHasProduct, sort });
  }
  /**
   * [Authorize] type: http
   */
  public productCategoriesGet$(page?: number, limit?: number, name?: string, language?: string, isActive?: boolean, filterHasProduct?: boolean, sort?: string): Observable<ProductCategoryPaginationResponseDto> {
    return this.api.get(`${apiBaseUrl()}/product-categories`, { page, limit, name, language, isActive, filterHasProduct, sort });
  }
  /**
   * [Authorize] type: http
   */
  public productCategoriesIdDelete$(id: string): Observable<string> {
    return this.api.delete(`${apiBaseUrl()}/product-categories/${encodeURIComponent(String(id))}`, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public productCategoriesIdGet$(id: string, language?: string): Observable<ProductCategoryResponseDto> {
    return this.api.get(`${apiBaseUrl()}/product-categories/${encodeURIComponent(String(id))}`, { language });
  }
  /**
   * [Authorize] type: http
   */
  public productCategoriesIdPut$(id: string, body: ProductCategoryRequestDto): Observable<ProductCategoryResponseDto> {
    return this.api.put(`${apiBaseUrl()}/product-categories/${encodeURIComponent(String(id))}`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public productCategoriesIdUpdateIsActivePatch$(id: string): Observable<string> {
    return this.api.patch(`${apiBaseUrl()}/product-categories/${encodeURIComponent(String(id))}/update-is-active`, undefined, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public productCategoriesPost$(body: ProductCategoryRequestDto): Observable<ProductCategoryResponseDto> {
    return this.api.post(`${apiBaseUrl()}/product-categories`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public productCategoriesPublicGet$(language?: string, sort?: string): Observable<Array<ProductCategoryResponseDto>> {
    return this.api.get(`${apiBaseUrl()}/product-categories/public`, { language, sort });
  }
}
